import { render, staticRenderFns } from "./warn.vue?vue&type=template&id=139d88d2&scoped=true"
import script from "./warn.vue?vue&type=script&lang=js"
export * from "./warn.vue?vue&type=script&lang=js"
import style0 from "./warn.vue?vue&type=style&index=0&id=139d88d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139d88d2",
  null
  
)

export default component.exports